import { app } from '../utils/store'

import Lenis from '@studio-freight/lenis'
import gsap from 'gsap'

class Scroll {
    // create = () => {
    //     app.root.setAttribute('virtualscroll',true)

    //     app.virtualscroll = new Lenis({
    //         duration: 1.2,
    //         easing: (t) => Math.min(1, 1.0001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
    //         direction: 'vertical', // vertical, horizontal
    //         gestureDirection: 'vertical', // vertical, horizontal, both
    //         smooth: true,
    //         mouseMultiplier: 1,
    //         smoothTouch: false,
    //         touchMultiplier: 1,
    //         infinite: false,
    //     })
        
    //     function renderAnimationFrames(time) {
    //         app.virtualscroll.renderAnimationFrames(time)
    //         requestAnimationFrame(renderAnimationFrames)
    //     }
        
    //     requestAnimationFrame(renderAnimationFrames)
    // }

    onLoadAnchor = () => {
        if(window.location.hash && window.location.hash.length > 0){
            document.addEventListener('DOMContentLoaded', () => {
                this.hash = window.location.hash

                console.log('Current hash: '+this.hash)
                
                var target = document.querySelector(this.hash),
                offset = target.getBoundingClientRect().top

                // window.location.hash = ''
            
                window.history.pushState({}, '', location.origin + location.pathname + location.search + this.hash)

                gsap.to(app.scroll, {
                    duration: gsap.utils.mapRange(0, app.scroll.scrollHeight, 0, 2.5, offset),
                    scrollTo: offset - app.nav.clientHeight,
                    ease: 'Power2.easeInOut',
                    onStart: () => { console.log('On start: '+window.location.hash) },
                    onComplete: () => { console.log('On complete: '+window.location.hash) }
                })
            })
        }
    }

    scrollBehaviour = (entry) => {
        entry.onclick = (event) => {
            var target = document.querySelector(event.target.hash),
                offset = target.offsetTop

            event.preventDefault()
            window.history.pushState({}, '', location.origin + location.pathname + location.search + event.target.hash)
            gsap.to(app.scroll, {
                duration: gsap.utils.mapRange(0, app.scroll.scrollHeight, 0, 2.5, offset),
                scrollTo: offset - app.nav.clientHeight,
                ease: 'Power2.easeInOut',
            })

            console.log(offset, app.nav.clientHeight)
        }
    }

    scrollToY = (entry) => {
        app.virtualscroll.scrollTo(Number(entry), false);
    }

    destroy = () => {
        app.virtualscroll.destroy()
        app.root.removeAttribute('virtualscroll')
    }
}

 export const ScrollManager = new Scroll()
